export default __webpack_public_path__ + "static/media/main-logo.9e41edc6.png";